import { useTenantStore } from '@/stores/tenant';

export function InvalidTenantPage() {
  const error = useTenantStore((state) => state.error);

  return (
    <div
      data-testid="invalid-tenant"
      className="flex min-h-screen flex-col items-center justify-center"
    >
      <h1 className="text-6xl font-bold">Error</h1>
      <p className="mt-4 text-xl text-muted-foreground">Invalid Tenant</p>
      <p className="mt-2 text-muted-foreground">
        {error || 'The workspace you are trying to access does not exist.'}
      </p>
    </div>
  );
}
